//create the validation object 
var mclValidation = (function (id) {
    //check the key up of the text box
    $(document).on("keyup", "#" + id + " input[type='text'], #" + id + " textarea, #" + id + " input[type='password'],#" + id + " input[type='number']", function (e) {
        e.preventDefault();

        //is this a required text box?
        if ($(this).data("val-required") == true) {
            add_errors(this, get_data(this));
        }
    });

    //check the blur of the text box
    $(document).on("blur", "#" + id + " input[type='text'], #" + id + " textarea, #" + id + " input[type='password'],#" + id + " input[type='number']", function (e) {
        e.preventDefault();

        //is this a required text box?
        if ($(this).data("val-required") == true) {
            add_errors(this, get_data(this));
        }
    });


    //check the change event for the validation objects to see if they are valid after their values are changed 
    $(document).on("change", "#" + id + " input[type='text'], #" + id + " textarea, #" + id + " input[type='password'],#" + id + " input[type='number']", function (e) {
        //is this a required text box?
        if ($(this).data("val-required") == true) {
            add_errors(this, get_data(this));
        }
    });

    //check for any errors on form submit 
    $(document).on("submit", "#" + id, function (e) {
        var el = this;
        var $el = $(this);
        var noErrors = true;

        if ($el.data("ajax-form") === undefined) {
            SpinnerSpin();
            //method var to see if there were any errors 
            $("#" + id + " input[type='text'], #" + id + " textarea, #" + id + " input[type='password'],#" + id + " input[type='number']").each(function (i, obj) {
                //is this a required text box?
                if ($(obj).data("val-required") == true) {
                    if (add_errors(obj, get_data(obj))) {
                        noErrors = false;
                    }

                    if ($(obj).hasClass("mclError2")) { //so that I can add an error to a form field that is unrelated to this validation class, but this class will consider it invalid
                        noErrors = false;
                    }
                }
            });

            //were there any errors while checking the form ?
            if (!noErrors) {
                SpinnerStop();
                return noErrors;
            }
        }
    });



    //public property for ajax submissions
    this.ajaxCheck = (function () {
        var Good = true;

        //run the same thing as the submit fucntion, but make it an actual function 
        $("#" + id + " input[type='text'], #" + id + " textarea, #" + id + " input[type='password'],#" + id + " input[type='number']").each(function (i, obj) {
            //is this a required text box?
            if ($(obj).data("val-required") == true) {
                if (add_errors(obj, get_data(obj))) {
                    Good = false;
                }

                if ($(obj).hasClass("mclError2")) {
                    Good = false;
                }
            }
        });
        return Good;
    });


    //private function to add the error classes 
    function add_errors(obj, error) {
        if (!error) {
            $(obj).addClass("mclError");
            return true;
        } else {
            $(obj).removeClass("mclError");            
            return false;
        }
    }


    //private function to determine which case to send to reg_check()
    function get_data(obj) {
        //obj is the HTML element that is being validated 
        return reg_check($(obj).val(), $(obj).data("val-type"));
    }


    //private function to check regex for the different items
    function reg_check(string, type) {
        switch (type) {
            case "email":
                var regEx = /\S+@\S+\.\S+/;
                return regEx.test(string);
                break;


            case "phone":
                var regEx = /^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/;
                return regEx.test(string);
                break;


            case "text":
                if (string.length > 0) { return true; } else { return false; }
                break;


            case "zip":
                var regEx = /^\d{5}(?:[-\s]\d{4})?$/;
                return regEx.test(string);
                break;


            case "date":
                var regEx = /[0-9]{1,2}[/][0-9]{1,2}[/][0-9]{4}$/;
                return regEx.test(string);
                break;

            case "number":
                var regEx = /(?:^(-)?|\s)([0-9](?:\d*|(?:\d{0,2})(?:,\d{3})*)(?:\.\d*[0-9])?|0?\.\d*[0-9]|0)(?:\s|$)/;
                return regEx.test(string);
                break;

            case "wholeNumber":
                var regEx = /^\d+$/;
                return regEx.test(string);
                break;

            case "creditCard":
                return LuhnCheck(string);
                break;
                //TODO: add any other cases to this to test for other possibilities I didn't consider

            case undefined:
                return true;
                break;
        }

    };


    //valid credit card algorithm
    var LuhnCheck = (function () {
        var luhnArr = [0, 2, 4, 6, 8, 1, 3, 5, 7, 9];
        return function (str) {
            var counter = 0;
            var incNum;
            var odd = false;
            var temp = String(str).replace(/[^\d]/g, "");
            if (temp.length == 0)
                return false;
            for (var i = temp.length - 1; i >= 0; --i) {
                incNum = parseInt(temp.charAt(i), 10);
                counter += (odd = !odd) ? incNum : luhnArr[incNum];
            }
            return (counter % 10 == 0);
        };
    })();
});